import { Helmet } from "@dr.pogodin/react-helmet";
import { useMemo } from "react";

/**
 * props:
 * - title, description, url, image
 * - locale: 'en_US' | 'bg_BG'
 * - alternates: [{ href, hreflang }]
 * - canonical
 * - jsonLd: object | object[]
 */
export default function SeoTags({
  title,
  description,
  url,
  image = "https://aura.example/og/og-hero.jpg",
  locale = "en_US",
  alternates = [],
  canonical,
  jsonLd
}) {
  const ld = useMemo(() => (Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []), [jsonLd]);

  return (
    <Helmet>
      {/* Title & meta */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}

      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Hreflang */}
      {alternates.map((a) => (
        <link key={a.hreflang} rel="alternate" href={a.href} hreflang={a.hreflang} />
      ))}

      {/* OG */}
      {url && <meta property="og:url" content={url} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="AURA" />
      <meta property="og:locale" content={locale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
